import React from 'react';

import { ROLLOUT_VIDEO_PLAYER_PRE_PLAY_SCREEN } from 'constants/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';

import OldEmbedTopbar from './old';
import EmbedTopbar from './rework';

export default function EmbedTopBar(props) {
  const showEmbedTopBar = useFlagIsActivated({
    flag: ROLLOUT_VIDEO_PLAYER_PRE_PLAY_SCREEN,
    activationValues: ['variant'],
  });

  return showEmbedTopBar ? (
    <EmbedTopbar {...props} />
  ) : (
    <OldEmbedTopbar {...props} />
  );
}
